import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './layouts/Home'
import PrivacyPolicy from './pages/PrivacyPolicy'
import TermsOfService from './pages/TermsOfService'
import ScrollHandler from './components/ScrollHandler'
import { Toaster } from 'react-hot-toast'

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <ScrollHandler />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route path='/terms-of-service' element={<TermsOfService />} />
      </Routes>
      <Toaster toastOptions={{ position: 'bottom-left' }} />
    </BrowserRouter>
  )
}

export default App
